module.exports = __webpack_public_path__ + "static/media/my-maps-selected.b5afbb4d.svg";